import _ from 'underscore';

/**
 * Check whether is edit status
 * @private
 * @param {JsonSchema} schema - Schema to Check
 * @param {Object} model - The value model passed in
 * @returns {boolean} - return true if is editing, otherwise, return false
 */
export function isEditing(schema, model) {
  let editing = !_.isEmpty(model);

  if (schema.key) {
    // more strict for schema with key
    editing = editing && model[schema.key];
  }

  return editing;
}

/**
 * Checke whether specified field is editing
 * @private
 * @param {Object|String} field - the field to check, it can be a key or a object
 * with property fields and hasSubFields
 * @param {Object} model - the value model passed in
 * @returns {boolean} - if the field is editing, return true, otherwise, return false
 */
export function isFieldEditing(field, model) {
  if (field.hasSubFields) {
    return _.some(field.fields, subField => isFieldEditing(subField, model));
  }

  return !_.chain(model)
    .result(field.property)
    .isEmpty()
    .value();
}
